module.exports = __webpack_public_path__ + "b9702da2456fe0003feea951e1d05214.svg";